import { CategoryEnum } from "@sprawdzonabron/shared";

import { CATEGORY_SLUG_TO_CATEGORY } from "../constants/categories";
import { CITIES } from "../constants/cities";

export const isKnownCategory = (category?: unknown) =>
  typeof category === "string" && Object.values(CategoryEnum).includes(category as CategoryEnum);

export const isKnownCategorySlug = (category?: unknown) =>
  typeof category === "string" && CATEGORY_SLUG_TO_CATEGORY[category];

export const isKnownCity = (city?: string) => typeof city === "string" && city in CITIES;
